
import axiosInstance from "@/utils/axiosInstance";


/**
 * Management API client
 * - Uses canonical axiosInstance (tenant header + refresh handling)
 * - Targets backend router mounted under /api/v1/management/*
 * - No stubs; all functions hit real endpoints.
 */

export type ManagementDashboardSummary = {
  // Keep minimal typing to avoid mismatches; UI can narrow later.
  [key: string]: unknown;
};

export interface ManagementQueueItem {
  submission_id: number;
  status: string;
  program_code?: string | null;
  academic_year?: number | null;
  current_owner_role?: string | null;
  lifecycle_phase: string;
  review_state: string;
  latest_governance_event: string;
  latest_return_source?: string | null;
  actionability_state: string;
  blocking_reason: string;
  executable_action_count: number;
}

export interface ManagementQueueResponse {
  authority: string;
  total: number;
  items: ManagementQueueItem[];
}

export async function fetchManagementSummary(params?: Record<string, unknown>) {
  const res = await axiosInstance.get<ManagementDashboardSummary>(
    "/management/dashboard-summary",
    { params }
  );
  return res.data;
}

export async function fetchManagementQueue(): Promise<ManagementQueueResponse> {
  const res = await axiosInstance.get<ManagementQueueResponse>(
    "/management/submissions/queue"
  );
  return res.data;
}

export async function submitManagementTransition(
  submissionId: number,
  payload: { action_code: string; remarks?: string }
) {
  const res = await axiosInstance.post(
    `/management/submissions/${submissionId}/transition`,
    payload
  );
  return res.data;
}

export async function fetchActionHistory(submissionId: number) {
  const res = await axiosInstance.get(`/management/action-history/${submissionId}`);
  return res.data;
}
